var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M7 22C7 21.4477 7.44772 21 8 21H12C12.5523 21 13 21.4477 13 22V41H7V22Z",
    fill: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M13 10C13 9.44772 13.4477 9 14 9H18C18.5523 9 19 9.44772 19 10V41H13V10Z",
    fill: "#AFB8C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M23 14C23 13.4477 23.4477 13 24 13H28C28.5523 13 29 13.4477 29 14V41H23V14Z",
    fill: "#D0D7DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M29 22C29 21.4477 29.4477 21 30 21H34C34.5523 21 35 21.4477 35 22V41H29V22Z",
    fill: "#AFB8C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "border",
    d: "M1 1V41H41",
    stroke: "#D0D7DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "bright-stroke",
    d: "M1 41L29 11L41 17",
    stroke: "#D0D7DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "deep-stroke",
    d: "M1 25L15 13L27 21L41 11",
    stroke: "#AFB8C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "border",
    d: "M1 1V41H41",
    stroke: "#D0D7DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombo);
export default __webpack_public_path__ + "static/media/combo.c476c452782689c2187c85e1869cd81b.svg";
export { ForwardRef as ReactComponent };